import { FetcherWithComponents, useActionData } from "react-router-dom";

import Toaster, { ToasterProps } from "components/Toaster";


export interface IToasterActionData {
  toaster?: ToasterProps;
}

export function useToasterFromActionData(fetcher?: FetcherWithComponents<any>) {
  const actionData = useActionData() as IToasterActionData | undefined;
  // fetcher.data can be kept between page loads, use it only when data is reloaded after a form submission
  const isFetcherReloadingAfterAction = (fetcher?.state === "loading") && (fetcher?.formData !== undefined);
  const fetcherData = isFetcherReloadingAfterAction ? fetcher?.data as IToasterActionData | undefined : undefined;

  if (actionData?.toaster) {
    Toaster.showToast(actionData.toaster);
  } else if (fetcherData?.toaster) {
    Toaster.showToast(fetcherData.toaster);
    // clearing toaster info to avoid duplicate toasts
    fetcherData.toaster = undefined;
  }
}

export function addToasterActionData<T>(actionData: T, toaster: ToasterProps): T & IToasterActionData {
  return { ...actionData, toaster };
}
